// Constants for different requests for current reducer
export default {
  notebookNote: 'NOTEBOOK_NOTE',
  shiftNote: 'SHIFT_NOTE',
  notebookNotes: 'NOTEBOOK_NOTES',
};
